module.exports = __webpack_public_path__ + "img/FO.f40c27ad.svg";